import Link from 'next/link';
import { SERVICE_AREAS_IMMEDIATE } from '@/lib/constants';
import { Button } from '@/components/ui/button';

export function ServiceAreas() {
  return (
    <section className="container py-12">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-semibold dark-text">Serving Casper, WY & Surrounding Areas</h2>
        <p className="mt-3 text-gray-600">Professional plastering, stucco, and drywall services throughout Casper and surrounding regions</p>
      </div>
      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {SERVICE_AREAS_IMMEDIATE.slice(0, 12).map((area) => (
          <Link
            key={area.slug}
            href={`/service-areas/${area.slug}`}
            className="p-4 rounded-lg border border-gray-200 hover:border-[color:var(--color-primary)] hover:shadow-md transition-all text-center group"
          >
            <div className="font-medium text-sm group-hover:text-[color:var(--color-primary)] transition-colors">
              {area.name}
            </div>
          </Link>
        ))}
      </div>
      <div className="mt-8 text-center">
        <p className="text-sm text-gray-600 mb-4">
          We also serve Natrona County, Glenrock, Douglas, and many additional communities.        </p>
        <Link href="/service-areas">
          <Button variant="outline" size="lg">
            View All Service Areas
          </Button>
        </Link>
      </div>
    </section>
  );
}
